module.exports = __webpack_public_path__ + "static/img/bilitu.9b6f060a.png";